import {
  IManualSuscriptionContractSummary,
  ManualSuscriptionContractTypeEnum,
} from '../../../../common/interfaces'

export const isMancomunado = (contract: IManualSuscriptionContractSummary) =>
  contract.tipoContrato.code === ManualSuscriptionContractTypeEnum.MANCOMUNADO_CONJUNTO ||
  contract.tipoContrato.code === ManualSuscriptionContractTypeEnum.MANCOMUNADO_INDISTINTO

export const getContractLabel = (contract: IManualSuscriptionContractSummary): string => {
  if (isMancomunado(contract) && contract.otrosParticipantes?.length) {
    const otherNames = contract.otrosParticipantes
      .map((participante) => participante.nombres)
      .join(', ')
    return `${contract.tipoContrato.label} con ${otherNames}`
  }

  return `${contract.tipoContrato.label} - ${contract.titular.nombres}`
}
